import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import KendoDropDownHelper from '@/Utility/KendoDropDownHelper';

/**
 * Das ViewModel für die AutoComplete
 */
export default class AutoCompleteViewModel extends ControlViewModel {

    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * Die verfügbaren Vorschläge
     */
    public data: KnockoutObservableArray<any>;

    /**
     * Der Wert der TextBox
     * Kann ein Observable beinhalten
     */
    public value: KnockoutObservable<string>;

    /**
     * Die minimale Textlänge zum Starten der Suche
     */
    public minLength: KnockoutObservable<number>;

    /**
     * Die maximale des Texteingabefelds
     */
    public maxLength: KnockoutObservable<number>;

    public placeholder: KnockoutObservable<string>;

    public clearOnFocusLost: KnockoutObservable<boolean>;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer die Eingabetaste drückt
     */
    public onSubmit: Function;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer ein Element selektiert
     */
    public onSelect: Function;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer die TextBox fokussiert
     */
    public onFocus: Function;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer eine Taste drückt
     */
    public onKeyUp: Function;

    /**
     * Ein Handler, der aufgerufen wird, wenn der Benutzer die TextBox anklickt
     */
    public onClick: Function;

    /**
     * startswith, endswith, contains or function
     */
    public filter: string;

    /**
     * Automatische Suche bei Fokussierung
     */
    public searchOnFocus: boolean;

    /**
     * Gibt an, ob gerade der Wert geleert wird
     */
    public isClearing: KnockoutObservable<boolean>;

    /**
     * Der ARIA-Label-Text für das Eingabefeld
     */
    public ariaLabel: string;

    /**
     * Tooltip wird hier überschrieben
     */
    public tooltip: LabelViewModel;

    /**
     * Das ViewModel für die AutoComplete
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.data = this.observableOrDefault(params.data, []) as KnockoutObservableArray<any>;
        this.value = this.observableOrDefault(params.value, '');
        this.minLength = this.observableOrDefault(params.minLength, 1);
        this.maxLength = this.observableOrDefault(params.maxLength, -1);
        this.placeholder = this.observableOrDefault(params.placeholder, '');
        this.onSubmit = this.handlerOrDefault(params.onSubmit);
        this.onSelect = this.handlerOrDefault(params.onSelect);
        this.onFocus = this.handlerOrDefault(params.onFocus);
        this.onKeyUp = this.handlerOrDefault(params.onKeyUp);
        this.onClick = this.handlerOrDefault(params.onClick);
        this.filter = this.paramOrDefault(params.filter, 'startswith');
        this.searchOnFocus = this.paramOrDefault(params.searchOnFocus, false);
        this.clearOnFocusLost = this.paramOrDefault(params.clearOnFocusLost, false);
        this.isClearing = this.observableOrDefault(false);
        this.ariaLabel = this.paramOrDefault(params.ariaLabel, '');
        this.tooltip = new this.LabelViewModel({
            caption: KendoDropDownHelper.createComputedTooltip(params.tooltip?.caption || '', 
                this.data, this.value, null, null,
                (sub) => this.subscriptionCollection.push(sub))
        });
    }

    /**
     * Leert die Eingabe
     */
    public clear(): void {
        this.isClearing(true);
        this.value('');
        this.isClearing(false);
    }
}

ComponentManager.setViewModel('AutoCompleteViewModel', AutoCompleteViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');